import * as THREE from 'three';
import * as CANNON from 'cannon-es';
import PhysVisUtil from "@/PhysVisUtil";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import CarEngine from './CarEngine';

class Car {
	
	carMode; // 0 - физика на основе first car shooter (едем по trimesh), 1 - raycastvehicle (едем по heightmap), 2 - rigidvehicle (пробуем ехать по trimesh) 
	
//	vehicle: CANNON.RaycastVehicle = null!;
	vehicle: any = null!;
	
	engine: CarEngine;
	
	sceneRootObject: THREE.Object3D;

	physVisUtil: any;
	
	wheelMaterial: CANNON.Material;

	world: CANNON.World;

	groundMaterial: CANNON.Material;
	
	frameBody: CANNON.Body = null!;
	wheelLFBody: CANNON.Body = null!;	
	wheelRFBody: CANNON.Body = null!;	
	wheelLBBody: CANNON.Body = null!;	
	wheelRBBody: CANNON.Body = null!;	

	// бразды управления для режима FCS
	constraintLF: CANNON.HingeConstraint = null!;
	constraintRF: CANNON.HingeConstraint = null!;
	constraintLB: CANNON.HingeConstraint = null!;
	constraintRB: CANNON.HingeConstraint = null!;


	// значения скорости и угла поворота колёс
    forwardVelocity = 0;
    rightVelocity = 0;
    
    // приращения скорости и угла поворота колёс
    dForwardVelocity = 0;
    
    // нажатость кнопок руля
    steeringLeft = false;
    steeringRight = false;
    
    wheelGround: CANNON.ContactMaterial = null!;
    
    visibleObjectGame: THREE.Object3D;  // отображение машины, режим игры (обычный)
    visibleObjectPhys: THREE.Object3D;  // отображение машины, режим показа физического представления
    showModePhys = false; // какой из двух режимов отображения активен (переключаем кнопкой)  

    frameMesh = new THREE.Mesh()

    wheelLFMesh = new THREE.Group()
    wheelRFMesh = new THREE.Group()
    wheelLBMesh = new THREE.Group()
    wheelRBMesh = new THREE.Group()

	wheelBodies: CANNON.Body[] = [];

//	maxSteerVal = 0.5;
//	maxForce = 2000;
//	brakeForce = 1000000;
//	
	
	prevPosition: CANNON.Vec3;
	
	fullDistance = 0;
	
	wheelRadius = 0.4;
	
	roadAmplitudeX;
	noise2D;
	
	autoSteering = false;
	
	braked = false;  // на тормозе или нет

	constructor(carMode: number, sceneRootObject: THREE.Object3D, world: CANNON.World, groundMaterial: CANNON.Material, 
				initX: number, initY: number, initZ: number, roadAmplitudeX: number, noise2D: any) {

		this.carMode = carMode;

		this.roadAmplitudeX = roadAmplitudeX;
		this.noise2D = noise2D;

		this.sceneRootObject = sceneRootObject;
		
		this.visibleObjectGame = new THREE.Object3D();
		sceneRootObject.add(this.visibleObjectGame);
		
		this.visibleObjectPhys = new THREE.Object3D();
		
		this.world = world;		

		this.groundMaterial = groundMaterial;
		
		// взаимодействие колёс с поверхностью		
		this.wheelMaterial = new CANNON.Material('wheel');

		
		this.physVisUtil = new PhysVisUtil(); 


		const options = {
			radius: this.wheelRadius,
			directionLocal: new CANNON.Vec3(0, -1, 0),
///			suspensionStiffness: 30,
			suspensionStiffness: 45,
///			suspensionRestLength: 0.3,
			suspensionRestLength: 0.4,
///			frictionSlip: 5,
			frictionSlip: 40,
//			frictionSlip: 2,
//			frictionSlip: 1.4,
			dampingRelaxation: 2.3,
			dampingCompression: 4.4,
//			maxSuspensionForce: 100000,
			maxSuspensionForce: 1000000,
//			maxSuspensionForce: 10000000,
			rollInfluence:  0.01,
///			rollInfluence:  0.05,
			axleLocal: new CANNON.Vec3(-1, 0, 0),
			chassisConnectionPointLocal: new CANNON.Vec3(1, 1, 0),
			maxSuspensionTravel: 0.3,
//			maxSuspensionTravel: 0.1,
///			customSlidingRotationalSpeed: -30,
			customSlidingRotationalSpeed: 0,
			useCustomSlidingRotationalSpeed: true
		};



		if (carMode == 0) {
//			this.frameBody = new CANNON.Body({ mass: 1500 })
//			this.frameBody = new CANNON.Body({ mass: 0.1 })
			this.frameBody = new CANNON.Body({ mass: 150 })
//			this.frameBody = new CANNON.Body({ mass: 3500 })
		} else if (carMode == 1) {
//        this.frameBody = new CANNON.Body({ mass: 150 })
//        this.frameBody = new CANNON.Body({ mass: 1500 })
//        this.frameBody = new CANNON.Body({ mass: 3000 })
//        this.frameBody = new CANNON.Body({ mass: 5000 })
			this.frameBody = new CANNON.Body({ mass: 7500 })
//        this.frameBody = new CANNON.Body({ mass: 50 })
		} else {
//			this.frameBody = new CANNON.Body({ mass: 100 })
			this.frameBody = new CANNON.Body({ mass: 1000 })
//			this.frameBody = new CANNON.Body({ mass: 3000 })
//			this.frameBody = new CANNON.Body({ mass: 7500 })
		}


		const centerMassY = 0.5;

        this.frameBody.addShape(
            new CANNON.Sphere(0.1),
            new CANNON.Vec3(0, 0.8 + centerMassY, 0.4)
        )
        this.frameBody.addShape(
            new CANNON.Sphere(0.1),
            new CANNON.Vec3(0, -0.1 + centerMassY, -1.3)
        )
        this.frameBody.addShape(
            new CANNON.Sphere(0.1),
            new CANNON.Vec3(0, -0.1 + centerMassY, 1.3)
        )
        this.frameBody.addShape(
			new CANNON.Sphere(0.1), 
			new CANNON.Vec3(1, -0.1 + centerMassY, 0)
		)
        this.frameBody.addShape(
            new CANNON.Sphere(0.1),
            new CANNON.Vec3(-1, -0.1 + centerMassY, 0)
        )

        
        this.frameBody.position.set(initX, initY, initZ);
		this.physVisUtil.addVisual(this.visibleObjectPhys, this.frameBody, "chassis", "", 0);
        
        this.frameBody.angularVelocity.set(0, 0, 0);
        
        this.prevPosition = new CANNON.Vec3();
        this.prevPosition.copy(this.frameBody.position); 

		//this.wheelGround = window.wheelGroundContactMaterial = new CANNON.ContactMaterial(this.wheelMaterial, this.groundMaterial, {		
        
        
		if (carMode == 0) {

			this.wheelGround = new CANNON.ContactMaterial(this.wheelMaterial, this.groundMaterial, {
//				friction: 0.3,
//				friction: 0.8,
///				friction: 0.4,
////				friction: 100,
				friction: 1000,
///				restitution: 0.5,
				restitution: 0,
//				contactEquationStiffness: 10000000,
///				contactEquationStiffness: 10000,
//				contactEquationStiffness: 1000,
				contactEquationStiffness: 100000000,
				contactEquationRelaxation: 3,
			});
			

///			const wheelMass = 0.1;
//			const wheelMass = 1;
			const wheelMass = 10;
//			const wheelMass = 100;
//			const wheelMass = 1;
//			const wheelMass = 0.5;

			const wheelLFShape = new CANNON.Sphere(0.35)
			this.wheelLFBody = new CANNON.Body({
				mass: wheelMass,
				material: this.wheelMaterial,
			})
			this.wheelLFBody.addShape(wheelLFShape)
			this.wheelLFBody.position.set(initX -1, initY + 0, initZ -1)
			//this.physics.world.addBody(this.wheelLFBody)

			const wheelRFShape = new CANNON.Sphere(0.35)
			this.wheelRFBody = new CANNON.Body({
				mass: wheelMass,
				material: this.wheelMaterial,
			})
			this.wheelRFBody.addShape(wheelRFShape)
			this.wheelRFBody.position.set(initX + 1, initY + 0, initZ -1)
			//this.physics.world.addBody(this.wheelRFBody)

			const wheelLBShape = new CANNON.Sphere(0.4)
			this.wheelLBBody = new CANNON.Body({
				mass: wheelMass,
				material: this.wheelMaterial,
			})
			this.wheelLBBody.addShape(wheelLBShape)
			this.wheelLBBody.position.set(initX -1, initY + 0, initZ + 1)
			//this.physics.world.addBody(this.wheelLBBody)

			const wheelRBShape = new CANNON.Sphere(0.4)
			this.wheelRBBody = new CANNON.Body({
				mass: wheelMass,
				material: this.wheelMaterial,
			})
			this.wheelRBBody.addShape(wheelRBShape)
			this.wheelRBBody.position.set(initX + 1, initY + 0, initZ + 1)
			//this.physics.world.addBody(this.wheelRBBody)



			const leftFrontAxis = new CANNON.Vec3(1, 0, 0)
			const rightFrontAxis = new CANNON.Vec3(1, 0, 0)
			const leftBackAxis = new CANNON.Vec3(1, 0, 0)
			const rightBackAxis = new CANNON.Vec3(1, 0, 0)

//const multForce = 10;
//			const multForce = 100;
///const multForce = 1000000;
const multForce = 100000000;
//const multForce = 1;
//const multForce = 1;
//const multForce = 0.1;

			this.constraintLF = new CANNON.HingeConstraint(
				this.frameBody,
				this.wheelLFBody,
				{
					pivotA: new CANNON.Vec3(-1, 0, -1),
					axisA: leftFrontAxis,
					maxForce: multForce * 0.66,
				}
			)
			this.world.addConstraint(this.constraintLF)
			
			this.constraintRF = new CANNON.HingeConstraint(
				this.frameBody,
				this.wheelRFBody,
				{
					pivotA: new CANNON.Vec3(1, 0, -1),
					axisA: rightFrontAxis,
					maxForce: multForce * 0.66,
				}
			)
			this.world.addConstraint(this.constraintRF)
			
			this.constraintLB = new CANNON.HingeConstraint(
				this.frameBody,
				this.wheelLBBody,
				{
					pivotA: new CANNON.Vec3(-1, 0, 1),
					axisA: leftBackAxis,
					maxForce: multForce * 0.66,
				}
			)
			this.world.addConstraint(this.constraintLB)
			
			this.constraintRB = new CANNON.HingeConstraint(
				this.frameBody,
				this.wheelRBBody,
				{
					pivotA: new CANNON.Vec3(1, 0, 1),
					axisA: rightBackAxis,
					maxForce: multForce * 0.66,
				}
			)
			this.world.addConstraint(this.constraintRB)

///			this.constraintLB.enableMotor();
///			this.constraintRB.enableMotor();

			this.physVisUtil.addVisual(this.visibleObjectPhys, this.wheelLFBody, "wheel", "");
			this.physVisUtil.addVisual(this.visibleObjectPhys, this.wheelRFBody, "wheel", "");
			this.physVisUtil.addVisual(this.visibleObjectPhys, this.wheelLBBody, "wheel", "");
			this.physVisUtil.addVisual(this.visibleObjectPhys, this.wheelRBBody, "wheel", "");

			setTimeout(() => {
				this.world.addBody(this.frameBody);
				this.world.addBody(this.wheelLFBody);
				this.world.addBody(this.wheelRFBody);
				this.world.addBody(this.wheelLBBody);
				this.world.addBody(this.wheelRBBody);
			}, 500)

        } else if (carMode == 1) {
			this.wheelGround = new CANNON.ContactMaterial(this.wheelMaterial, this.groundMaterial, {
				friction: 0.3,
				restitution: 0,
//          	restitution: 0.5,
				contactEquationStiffness: 1000,
			});
			
			// режим raycastvehicle
			this.vehicle = new CANNON.RaycastVehicle({
				chassisBody: this.frameBody,
			});

			console.log("this.vehicle.indexUpAxis = " + this.vehicle.indexUpAxis);
			console.log("this.vehicle.indexRightAxis = " + this.vehicle.indexRightAxis);
			console.log("this.vehicle.indexForwardAxis = " + this.vehicle.indexForwardAxis);
			this.vehicle.indexUpAxis = 1;
			this.vehicle.indexRightAxis = 0; 
			this.vehicle.indexForwardAxis = 2;

			const wheelY = 0.3;

			options.chassisConnectionPointLocal.set(1, wheelY, -1);
			this.vehicle.addWheel(options);

			options.chassisConnectionPointLocal.set(-1, wheelY, -1);
			this.vehicle.addWheel(options);

			options.chassisConnectionPointLocal.set(1, wheelY, 1);
			this.vehicle.addWheel(options);

			options.chassisConnectionPointLocal.set(-1, wheelY, 1);
			this.vehicle.addWheel(options);

			this.vehicle.addToWorld(this.world);
		
			for(let i = 0; i < this.vehicle.wheelInfos.length; i++) {
			
				console.log("колесо " + i);			
			
				const wheel = this.vehicle.wheelInfos[i];
				///const wheelShape = new CANNON.Cylinder(wheel.radius, wheel.radius, wheel.radius / 2, 20);
				const wheelShape = new CANNON.Sphere(wheel.radius);
//                const wheelBody = new CANNON.Body({ mass: 1});
                const wheelBody = new CANNON.Body({ mass: 1, material: this.wheelMaterial });
                
				wheelBody.type = CANNON.Body.KINEMATIC
				wheelBody.collisionFilterGroup = 0 // turn off collisions
                
                const q = new CANNON.Quaternion();
                q.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), Math.PI / 2);
///                q.setFromAxisAngle(new CANNON.Vec3(0, 0, 1), -Math.PI / 2);
//                wheelBody.addShape(cylinderShape, new CANNON.Vec3(), q);
//                wheelBody.addShape(wheelShape, new CANNON.Vec3(), q);
                wheelBody.addShape(wheelShape);
                this.wheelBodies.push(wheelBody);
                
				this.world.addBody(wheelBody);                
                
                //demo.addVisual(wheelBody);
				this.physVisUtil.addVisual(this.visibleObjectPhys, wheelBody, "wheel", "");
			}

			this.wheelLFBody = this.wheelBodies[0]; 
			this.wheelRFBody = this.wheelBodies[1]; 
			this.wheelLBBody = this.wheelBodies[2]; 
			this.wheelRBBody = this.wheelBodies[3]; 
			
		} else {
			// carMode == 2
			this.wheelGround = new CANNON.ContactMaterial(this.wheelMaterial, this.groundMaterial, {
//				friction: 0.3,
//				friction: 10,
				friction: 50,
//				friction: 5000,
//				friction: 1,
//				restitution: 0.5,
				restitution: 0,  // с нулевым значением машину меньше подбрасывает
//				contactEquationStiffness: 1000,
//				contactEquationStiffness: 100000,
//				contactEquationStiffness: 1000000,
//				contactEquationStiffness: 10000000,  // при меньших значениях можно застрять в поверхности
//				contactEquationStiffness: 500000,
				contactEquationStiffness: 100000000,
				contactEquationRelaxation: 3,
//				contactEquationRelaxation: 2,
//				contactEquationRelaxation: 1,  // но всё дрожит
			});
			
			this.vehicle = new CANNON.RigidVehicle({
				chassisBody: this.frameBody,
			});
			

//			const wheelMass = 1;
//			const wheelMass = 100;  
			const wheelMass = 1000; // при такой массе колесо не поворачивается в странных направлениях
//			const wheelMass = 50; 
//			const wheelMass = 10;  
//const axisWidth = 7;
			const wheelShape = new CANNON.Sphere(this.wheelRadius);
			const down = new CANNON.Vec3(0, -1, 0);

///			const wheelY = -0.1;
			const wheelY = 0;

			this.wheelLFBody = new CANNON.Body({ mass: wheelMass, material: this.wheelMaterial });
			this.wheelLFBody.addShape(wheelShape);
			this.vehicle.addWheel({
				body: this.wheelLFBody,
				//position: new CANNON.Vec3(-5, 0, axisWidth / 2).vadd(centerOfMassAdjust),
				position: new CANNON.Vec3(-1, wheelY, -1),
//				axis: new CANNON.Vec3(0, 0, 1),
				axis: new CANNON.Vec3(1, 0, 0),
				direction: down,
				isFrontWheel: true,
			});



			this.wheelRFBody = new CANNON.Body({ mass: wheelMass, material: this.wheelMaterial });
			this.wheelRFBody.addShape(wheelShape);
			this.vehicle.addWheel({
				body: this.wheelRFBody,
				//position: new CANNON.Vec3(-5, 0, -axisWidth / 2).vadd(centerOfMassAdjust),
				position: new CANNON.Vec3(1, wheelY, -1),
//				axis: new CANNON.Vec3(0, 0, 1),
				axis: new CANNON.Vec3(1, 0, 0),
				direction: down,
				isFrontWheel: true,
			});

			this.wheelLBBody = new CANNON.Body({ mass: wheelMass, material: this.wheelMaterial });
			this.wheelLBBody.addShape(wheelShape);
			this.vehicle.addWheel({
				body: this.wheelLBBody,
//          position: new CANNON.Vec3(5, 0, axisWidth / 2).vadd(centerOfMassAdjust),
				position: new CANNON.Vec3(-1, wheelY, 1),
//				axis: new CANNON.Vec3(0, 0, -1),
				axis: new CANNON.Vec3(-1, 0, 0),
				direction: down,
			});

			this.wheelRBBody = new CANNON.Body({ mass: wheelMass, material: this.wheelMaterial });
			this.wheelRBBody.addShape(wheelShape);
			this.vehicle.addWheel({
				body: this.wheelRBBody,
//          position: new CANNON.Vec3(5, 0, -axisWidth / 2).vadd(centerOfMassAdjust),
				position: new CANNON.Vec3(1, wheelY, 1),
//				axis: new CANNON.Vec3(0, 0, -1),
				axis: new CANNON.Vec3(-1, 0, 0),
				direction: down,
			});

			for(let i = 0; i < this.vehicle.wheelBodies.length; i++) {
			
				console.log("колесо " + i);			
			
				const wheelBody = this.vehicle.wheelBodies[i];

//wheelBody.fixedRotation = true;
//wheelBody.updateMassProperties();
				
				wheelBody.angularDamping = 0.4;

				this.physVisUtil.addVisual(this.visibleObjectPhys, wheelBody, "wheel", "");
			}

			this.vehicle.addToWorld(world);
			
		}

		this.world.addContactMaterial(this.wheelGround);
		
		// загружаем 3D-модель
        const pipesMaterial = new THREE.MeshStandardMaterial()
        pipesMaterial.color = new THREE.Color('#ffffff')
//        pipesMaterial.refractionRatio = 0
        pipesMaterial.roughness = 0.2
        pipesMaterial.metalness = 1
		
        const loader = new GLTFLoader()
        loader.load('/models/cars/frame.glb', (gltf) => {
                this.frameMesh = gltf.scene.children[0] as THREE.Mesh
                this.frameMesh.material = pipesMaterial
                this.frameMesh.castShadow = true
                this.visibleObjectGame.add(this.frameMesh)

                loader.load(
                    '/models/cars/tyre.glb',
                    (gltf) => {
                        this.wheelLFMesh = gltf.scene
                        this.wheelLFMesh.children[0].castShadow = true
                        this.wheelRFMesh = this.wheelLFMesh.clone()
                        this.wheelLBMesh = this.wheelLFMesh.clone()
                        this.wheelRBMesh = this.wheelLFMesh.clone()
                        this.wheelLFMesh.scale.setScalar(0.87)
                        this.wheelRFMesh.scale.setScalar(0.87)
                        this.visibleObjectGame.add(this.wheelLFMesh)
                        this.visibleObjectGame.add(this.wheelRFMesh)
                        this.visibleObjectGame.add(this.wheelLBMesh)
                        this.visibleObjectGame.add(this.wheelRBMesh)
                    },
                    (xhr) => {
                        console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
                    },
                    (error) => {
                        console.log(error)
                    }
                )
            },
            (xhr) => {
                console.log((xhr.loaded / xhr.total) * 100 + '% loaded')
            },
            (error) => {
                console.log(error)
            }
        )
		
		this.engine = new CarEngine(this, this.vehicle);

	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	getPhysBodyPosition() {
		return this.frameBody.position;
	}
	getPhysBodyQuaternion() {
		return this.frameBody.quaternion;
	}
	getPhysBodyVelocity() {
		return this.frameBody.velocity;
	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	control(eventVal: string) {
		// управление машиной
		
		this.engine.playerControl(eventVal);

          switch (eventVal) {
/*			  
            case 'u+':  // forward: press 
				this.dForwardVelocity = 1.25;
				break;

            case 'd+':  // backward: press
				this.dForwardVelocity = -1.25;
				break;
*/				

            case 'l+':
				//this.dRightVelocity = -0.1;
				this.steeringLeft = true;
				break;

            case 'r+':
				//this.dRightVelocity = 0.1;
				this.steeringRight = true;
				break;

/*			  
            case 'u-':
              this.dForwardVelocity = 0;
              this.forwardVelocity = 0;
              break

            case 'd-':
              this.dForwardVelocity = 0;
              this.forwardVelocity = 0;
              break
*/
            case 'l-':
				this.steeringLeft = false;
				break;

            case 'r-':
				this.steeringRight = false;
				break;
          }
		
	}
	/////////////////////////////////////////////////////////
	updateVisuals() {
		this.physVisUtil.updateVisuals();
	}
	/////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////
	animate() {
		// (сразу после world.step)
		
		if (this.carMode == 2) {
			// дополнительное давление на колёса (частично разделяем инертные и гравитационные массы)
			for(let i = 0; i < this.vehicle.wheelBodies.length; i++) {
			
				console.log("колесо " + i);			
			
				const wheelBody: CANNON.Body = this.vehicle.wheelBodies[i];
				
//				wheelBody.applyForce(new CANNON.Vec3(0, -10000, 0));
				wheelBody.applyForce(new CANNON.Vec3(0, -30000, 0));
//				wheelBody.applyForce(new CANNON.Vec3(0, -3000, 0));
			
			}
		}
		

		const euler:CANNON.Vec3 = new CANNON.Vec3();
		this.frameBody.quaternion.toEuler(euler);
				
		euler.normalize();
			
		let st = document.getElementById("carVector");
		if (st != null) {
			st.innerHTML = ("" + euler).replaceAll(",", "<br>");
		}

		st = document.getElementById("carForce");
		if (st != null) {
			st.innerHTML = ("" + this.frameBody.force).replaceAll(",", "<br>");
		}
		
		// вместо postStep перенёс сюда
		if (this.carMode == 1) {
			for (let i = 0; i < this.vehicle.wheelInfos.length; i++) {
				this.vehicle.updateWheelTransform(i);
				const t = this.vehicle.wheelInfos[i].worldTransform;
				this.wheelBodies[i].position.copy(t.position);
				this.wheelBodies[i].quaternion.copy(t.quaternion);
			}
		}
		
		
		
		// текущую скорость определяем как разницу позиций этой и предыдущей итераций,
		// делённую на время между итерациями (1/60 сек)
		const iterationDistance: number = this.prevPosition.distanceTo(this.frameBody.position);  // метры
//		const iterationDistance: number = this.prevPosition.z - this.frameBody.position.z;  // метры
		
		this.fullDistance += iterationDistance; 
		

		console.log("prevPosition = " + this.prevPosition);
		console.log("position = " + iterationDistance);
		
		console.log("iterationDistance = " + iterationDistance);
		console.log("fullDistance = " + this.fullDistance);
		
		const speed: number = iterationDistance * 60;  // что = / (1 / 60); м/с

		console.log("speed = " + speed);
		
		st = document.getElementById("carSpeed");
		if (st != null) {
			st.innerHTML = "" + (Math.round(speed * 3.6 * 10) / 10) + " км/ч";
		}
		
		this.engine.actionStep(speed);  // из скорости определяем текущий RPM, сопротивление воздуха, трение качения

		/*
		st = document.getElementById("carPositionPrev");
		if (st != null) {
			st.innerHTML = ("" + this.prevPosition).replaceAll(',', "<br>");
//			st.innerHTML = ("" + this.prevPosition.z).replaceAll(',', "<br>");
		}
		st = document.getElementById("carPositionCur");
		if (st != null) {
			st.innerHTML = ("" + this.frameBody.position).replaceAll(',', "<br>");
//			st.innerHTML = ("" + this.frameBody.position.z).replaceAll(',', "<br>");
		}
		
		st = document.getElementById("iterationDistance");
		if (st != null) {
			st.innerHTML = "" + iterationDistance;
		}
		*/

		this.prevPosition.copy(this.frameBody.position);
		


        this.frameMesh.position.copy(this.frameBody.position);
        this.frameMesh.quaternion.copy(this.frameBody.quaternion);

        this.wheelLFMesh.position.copy(this.wheelLFBody.position);
        this.wheelLFMesh.quaternion.copy(this.wheelLFBody.quaternion);

        this.wheelRFMesh.position.copy(this.wheelRFBody.position);
        this.wheelRFMesh.quaternion.copy(this.wheelRFBody.quaternion);

        this.wheelLBMesh.position.copy(this.wheelLBBody.position);
        this.wheelLBMesh.quaternion.copy(this.wheelLBBody.quaternion);

        this.wheelRBMesh.position.copy(this.wheelRBBody.position);
        this.wheelRBMesh.quaternion.copy(this.wheelRBBody.quaternion);
		
		
		if (this.steeringRight && !this.steeringLeft) {
			if (this.rightVelocity >= -0.5) {
				this.rightVelocity -= 0.005; 
///				this.rightVelocity -= 0.0005; 
			}
		}

		if (this.steeringLeft && !this.steeringRight) {
			if (this.rightVelocity <= 0.5) {
				this.rightVelocity += 0.005;
///				this.rightVelocity += 0.0005;
			}	 
		}

		if (!this.steeringLeft && !this.steeringRight) {
			this.rightVelocity = this.lerp(this.rightVelocity, 0, 0.9);
			
			if (Math.abs(this.rightVelocity) < 0.0125) {
				this.rightVelocity = 0;
			}
			
		}

		if (this.carMode == 0) {
			this.constraintLF.axisA.z = -this.rightVelocity;
			this.constraintRF.axisA.z = -this.rightVelocity;
		} else {
			this.vehicle.setSteeringValue(this.rightVelocity, 0);
			this.vehicle.setSteeringValue(this.rightVelocity, 1);
		}
	
		
		st = document.getElementById("steering");
		if (st != null) {
			st.innerHTML = "" + this.rightVelocity;
		}
		
		st = document.getElementById("positionX");
		if (st != null) {
			st.innerHTML = "" + (Math.round(this.getPhysBodyPosition().x * 10) / 10);
		}
		st = document.getElementById("positionY");
		if (st != null) {
			st.innerHTML = "" + (Math.round(this.getPhysBodyPosition().y * 10) / 10);
		}
		st = document.getElementById("positionZ");
		if (st != null) {
			st.innerHTML = "" + (Math.round(this.getPhysBodyPosition().z * 10) / 10);
		}
		
	}
	/////////////////////////////////////////////////////////
    lerp = (x: number, y: number, a: number): number => {
        return (1 - a) * x + a * y
    }
	/////////////////////////////////////////////////////////
	changeShowMode() {
		this.showModePhys = !this.showModePhys;
		
		if (this.showModePhys) {
			this.sceneRootObject.remove(this.visibleObjectGame);
			this.sceneRootObject.add(this.visibleObjectPhys);
		} else {
			this.sceneRootObject.remove(this.visibleObjectPhys);
			this.sceneRootObject.add(this.visibleObjectGame);
		}
		
	}
	/////////////////////////////////////////////////////////
	brakeOn(brakeForce: number) {
		this.braked = true;
		if (this.carMode == 0) {
			this.constraintLB.setMotorSpeed(0);
			this.constraintRB.setMotorSpeed(0);
		} else if (this.carMode == 1) {	
			this.vehicle.setBrake(brakeForce, 0);
			this.vehicle.setBrake(brakeForce, 1);
			this.vehicle.setBrake(brakeForce, 2);
			this.vehicle.setBrake(brakeForce, 3);
		} else {
			// тормоз в RigidVehicle не предусмотрен, делаем свой
//			for(let i = 0; i < this.vehicle.wheelBodies.length; i++) {
			for(let i = 2; i < this.vehicle.wheelBodies.length; i++) {  // рулевые колёса не блокируем, а то некрасиво отъезжают от кузова при поворотах на тормозе
				const wheelBody = this.vehicle.wheelBodies[i];
				wheelBody.fixedRotation = true;
				wheelBody.updateMassProperties();
			}
		}
	}
	brakeOff() {
		this.braked = false;
		if (this.carMode == 1) {
			this.vehicle.setBrake(0, 0);
			this.vehicle.setBrake(0, 1);
			this.vehicle.setBrake(0, 2);
			this.vehicle.setBrake(0, 3);
		} else if (this.carMode == 2) {
			// тормоз в RigidVehicle не предусмотрен, делаем свой
//			for(let i = 0; i < this.vehicle.wheelBodies.length; i++) {
			for(let i = 2; i < this.vehicle.wheelBodies.length; i++) {  // рулевые колёса не блокируем, а то некрасиво отъезжают от кузова при поворотах на тормозе
				const wheelBody = this.vehicle.wheelBodies[i];
				wheelBody.fixedRotation = false;
				wheelBody.updateMassProperties();
			}
		}
	}
	/////////////////////////////////////////////////////////
	getWheelRadius() {
		return this.wheelRadius;
	}
	/////////////////////////////////////////////////////////
	switchAutoSteering(autoSteeringChecked: boolean) {
		this.engine.switchAutoSteering(autoSteeringChecked);
	}
	/////////////////////////////////////////////////////////
	
	
}
export default Car;